
import React from "react";
const Modal_left_section = (props) => {

  return (
    <div className="leftsection">
      <ul class="nav nav-tabs" role="tablist">

        {props.trigger &&
          props.trigger.slice(0).map((li, idx) => {
            var name = li.name;
            var id = li.id;
            var type = li.type;
            var category = li.category;
            return (
              <li role="presentation">
                <a
                  href={"#" + "metaData"}
                  role="tab"
                  onClick={() =>
                    props.handleClick({ name, id, type, category })
                  }
                  className={props.id && props.id == id ? "active" : ""}
                  data-toggle="tab"
                >
                  {li.name}
                </a>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default Modal_left_section;
